<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_intro')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})

const goToResources = () => {
  router.push('/resources')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        We have just built our first terraformer on a planet!
      </p>
      <p class="pb-2">
        Terraforming allows us to convert planets that aren't very compatible with our species to the preferred type, ultimately improving its production.
      </p>
      <p class="pb-2">
        <strong>To terraform a planet you need to</strong><br>
        • Build a terraformer building on the planet<br>
        • Collect enough ore required for the terraforming process<br>
        • Enable terraforming for the planet<br>
      </p>
      <p class="pb-2">
        Let's go to the resources section to take a better look.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Navigate to the Resources section
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Resources".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnResourcesSection" @click="goToResources" class="mr-2">
        Go to Resources
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Im there
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>